import {Component, OnInit, OnDestroy, Input, ViewContainerRef, Renderer2, ElementRef} from '@angular/core';
import {TrelloChecklist} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-checklist';
import {User} from 'projects/core/src/lib/login/data/user';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {trackEntityById} from 'projects/core/src/public-api';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {TrelloService} from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
  ProjectWindowComponent
} from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {WsUpdateResponce} from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import {TrelloCheckItem} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import {tap, filter} from 'rxjs/operators';
import {EditWorkOrderItemsComponent} from './edit-work-order-items/edit-work-order-items.component';
import {Task} from '../../../../../data/tasks/task';
import {CheckItemHeadTag} from 'projects/app-misc/src/app/modules/trello-misc/data/checkitem-head-tag';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {
  ProjectFile
} from '../../../../../../../../../../app-misc/src/app/modules/project-misc/data/project/project-file';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {DeviceDetectorService} from 'ngx-device-detector';
import {FileService} from 'projects/core/src/lib/misc/data/file/file.service';
import {FileOpenerService} from 'projects/app-misc/src/app/modules/project-misc/utils/fileOpener.service';
import {MvcExceptionResponse} from '../../../../../../../../../../core/src/lib/core/data/mvc-exception-response';
import {MiscSnackBarService} from '../../../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';

@Component({
  selector: 'app-task-checkitem',
  templateUrl: './task-checkitem.component.html',
  styleUrls: ['./task-checkitem.component.scss'],
  providers: [DeviceDetectorService]
})
export class TaskCheckitemComponent implements OnInit, OnDestroy {

  @Input()
  tempTask: Task;

  @Input()
  projectId: number;

  @Input()
  projectName: string;

  @Input()
  users: User[];

  @Input()
  currentUser: User;

  deleteChecklistIds = [];
  idsToDelete = [];
  editItem = -1;

  checkListForAdd = -1;

  trackEntityById = trackEntityById;

  loadingSpinnerId: number;

  tags: SelectItem[];

  isMobile: boolean;
  serviceDep: boolean;
  choosenCheckItem: TrelloCheckItem;

  constructor(
    private miscSnackBarService: MiscSnackBarService,
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    protected el: ElementRef,
    protected wsService: WsService,
    protected projectService: ProjectService,
    protected trelloService: TrelloService,
    protected appStateQuery: AppStateQuery,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ProjectWindowComponent>,
    protected viewContainerRef: ViewContainerRef,
    protected renderer: Renderer2,
    private userService: UserService,
    protected confirmationService: ConfirmationService,
    private deviceDetector: DeviceDetectorService
  ) {
    this.isMobile = this.deviceDetector.isMobile()
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(user => {
      this.currentUser = user
      this.serviceDep = !!this.currentUser.roles.find(role => role.name === 'Service Department')
    })

    this.appStateQuery.currentUser$.subscribe(user => this.currentUser = user);

    this.trelloService.checkItemLoading$.subscribe(emit => {
      this.loadingSpinnerId = emit
    })
    if (!this.tempTask.checkitems) {
      this.tempTask.checkitems = []
    }
    this.tempTask.checkitems.map(item => {
      return item;
    })

    const tempMap = new Map();
    this.currentUser.roles.forEach(role => {
      tempMap.set(role.id, role.name)
    })

    this.tempTask.checkitems.forEach(item => {
      if (item.tags) {
        item.tags.sort((taga, tagb) => taga.type.pos - tagb.type.pos)
      }
    })

    this.getTags()
  }

  getTags() {
    this.trelloService.getTags().subscribe(tags => {
      this.tags = tags.map(tag => {
        const val = {
          label: tag.title,
          value: {
            id: tag.id,
            name: tag.name,
            color: tag.color,
            pos: tag.pos
          }
        }
        return val;
      });
    })
  }


  hideAccord(checklist: TrelloChecklist) {
    let count = 0;
    checklist.checkItems.forEach(item => {
      if (item.ready) {
        count++;
      }
    })
    if (count === checklist.checkItems.length && checklist.checkItems.length > 0) {
      return 1;
    } else {
      return 0;
    }
  }

  countPunchlist(checklist: TrelloChecklist) {
    let count = 0;
    checklist.checkItems.forEach(item => {
      if (item.ready) {
        count++;
      }
    })
    return count + '/' + checklist.checkItems.length;
  }

  toggleReady(checkItem: TrelloCheckItem) {
    if (checkItem.tags && checkItem.tags.length > 0) {
      if (this.currentUser.adminNSuperNSales) {
        this.altToggleReady(checkItem)
      }
    } else {
      this.altToggleReady(checkItem)
    }

  }

  altToggleReady(checkItem: TrelloCheckItem) {
    checkItem.ready = !checkItem.ready

    this.projectService
      .saveCheckItem({
        id: checkItem.id,
        ready: checkItem.ready
      })
      .subscribe(() => {
      }, error => {
        checkItem.ready = !checkItem.ready
      })

    if (checkItem.ready && this.isMobile && this.serviceDep) {
      this.attachPhoto(checkItem)
    }

  }

  attachPhoto(checkItem: TrelloCheckItem) {
    this.confirmationService.confirm({
      header: 'Attach Photo',
      message: `Would you like to attach photo?`,
      dismissableMask: true,
      icon: 'pi pi-paperclip',
      accept: () => {
        const input = this.el.nativeElement.getElementsByClassName('mobile-photo-input')[0] as HTMLInputElement
        if (input) {
          input.click()
          this.choosenCheckItem = checkItem
        }
      }
    });
  }

  onFileSelected(event) {
    const file = event.target.files[0]

    this.trelloService.checkItemLoading$.next(this.choosenCheckItem.id);
    this.trelloService.uploadFile([file], this.choosenCheckItem.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.choosenCheckItem.files = this.choosenCheckItem.files.concat(projectFiles)
        this.trelloService.checkItemLoading$.next(-1)
      }
    }, error => {
      this.trelloService.checkItemLoading$.next(-1)
    })
  }

  toggleDeleteChecklist(event: any, checkList: TrelloChecklist) {
    event.stopPropagation();
    if (this.deleteChecklistIds.includes(checkList.id)) {
      const index = this.deleteChecklistIds.indexOf(checkList.id, 0);
      this.deleteChecklistIds.splice(index, 1)
    } else {
      this.deleteChecklistIds.push(checkList.id)
    }
  }

  editCheckItem(checkItem: TrelloCheckItem) {
    this.editItem = checkItem.id;
  }

  canEditCheckitemText(): boolean {
    if (this.tempTask.clazz !== 'SERVICE_ORDER_TASK') {
      return true;
    }

    if (!this.tempTask.isLock) {
      return true;
    }

    if (this.tempTask.assignedUser?.id === this.currentUser?.id || this.currentUser?.serviceDepartmentUser) {
      return true;
    }

    return false;
  }

  canEditCheckitems(): boolean {
    if (this.tempTask.clazz !== 'SERVICE_ORDER_TASK') {
      return true;
    }

    if (!this.tempTask.isLock) {
      return true;
    }

    if (this.tempTask.assignedUser?.id === this.currentUser?.id) {
      return true;
    }

    return false;
  }

  addCheckItem(checkList: TrelloChecklist) {
    this.editItem = -2;
    this.checkListForAdd = checkList.id;
  }

  deleteCheckItem(checkItem: TrelloCheckItem) {
    this.trelloService.deleteCheckItem(checkItem.id).subscribe(() => {
          const index = this.tempTask.checkitems.indexOf(checkItem, 0);
          if (index > -1) {
            this.tempTask.checkitems.splice(index, 1);
          }

          this.editItem = -1;
        },
        error => {
          if (error instanceof MvcExceptionResponse) {
            this.miscSnackBarService.openErrorSnackBar(error.message)
          } else {
            console.error(error)
            this.miscSnackBarService.openErrorSnackBar('Failed to delete check item')
          }
        })
  }

  onEditBlockClosed() {
    this.editItem = -1;
    this.checkListForAdd = -2;
  }

  onUpdateItem(event: TrelloCheckItem) {
    const foundedItem = this.tempTask.checkitems.find(item => item.id === event.id)
    foundedItem.name = event.name;
    foundedItem.tags = event.tags.sort((taga, tagb) => taga.type.pos - tagb.type.pos)
    this.editItem = -1;
  }

  showLoadingSpinner(event: number) {
    this.loadingSpinnerId = event;
  }

  // openPdfPreview(): void {
  // 	// this.sendData.emit(this.currentUser)
  // 	const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
  // 		data: {
  // 			dialogHeader: this.project.name,
  // 			link: '/pdf/punch-list?id=' + this.project.id
  // 		},
  // 		disableClose: true,
  // 		panelClass: 'pdf-preview-dialog'
  // 	});
  // 	cpDialogRef.afterOpened().subscribe(() => {
  // 		this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
  // 	})
  // 	cpDialogRef.afterClosed().subscribe(() => {
  // 		this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
  // 	})
  // }

  stopDrag() {
    // timer(500).subscribe(emit => {
    // 	console.log('DRAG')
    // })
  }

  openEditor() {
    const dialogRef = this.dialog.open(EditWorkOrderItemsComponent, {
      data: {
        taskId: this.tempTask.id,
        projectId: this.projectId,
        projectName: this.projectName,
        orderItemsId: this.tempTask.checkitems.map(item => item.id)
      },
      panelClass: 'edit-work-order-modal-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((task: Task) => {
      if (task.checkitems) {
        this.tempTask.checkitems = task.checkitems;
      }
    });
  }

  toggleTag(event, tag: CheckItemHeadTag) {
    event.stopPropagation();

    if (this.isTagDisabled(tag)) {
      return;
    }

    tag.ready = !tag.ready
    this.trelloService
      .toggleTag({
        id: tag.id,
        ready: tag.ready
      })
      .subscribe(() => {
      }, error => {
        tag.ready = !tag.ready
      })
  }

  isTagDisabled(tag: CheckItemHeadTag): boolean {
    if (this.tempTask.clazz !== 'WORK_ORDER_TASK') {
      return false;
    }

    if (!this.tempTask.createdByTagName) {
      return false;
    }

    const allowedTagTypes = this.tempTask.createdByTagName.split(',').map(t => t.trim());
    return !allowedTagTypes.includes(tag.type?.name);
  }

  canEditCheckitemTags(): boolean {
    return true;
  }

  openFile(event, projectFile: ProjectFile, checkItem: TrelloCheckItem) {
    event.stopPropagation()
    this.fileOpenerService.openFile(projectFile, checkItem.files, true)
  }

  ngOnDestroy() {

  }
}
